import "./index.scss";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../authProvider";
import DevisService from "../../services/devis.service";
import iconDevise from "../../assets/devise.png";
import iconDate from "../../assets/iconDate.png";
import icondeleteDevise from "../../assets/delete.png";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import ToggleMenuIcon from "../icons/toggleIcon";
import { useNavigate } from "react-router-dom";
import EditDevis from "../modaleditDevis";
import CompaniesService from "../../services/companies.service";

function DevisUser({
  devisList,
  fetchUserDevis,
  viewMode = "grid",
  companyId,
}) {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(6);
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  const [selectedDevis, setSelectedDevis] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [factureStatus, setFactureStatus] = useState({});
  const [status, setStatus] = useState("");
  const [statusFacture, setStatusFacture] = useState("");

  const toggleMenu = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
  };

  const getStatusColor = (currentStatus) => {
    switch (currentStatus?.toLowerCase()) {
      case "nouveau":
        return "bg-blue";
      case "en cours":
        return "bg-orange";
      case "traité":
        return "bg-green";
      default:
        return "bg-blue";
    }
  };

  const getFactureStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "payé":
      case "livré":
        return "text-success fw-bold";
      case "non payé":
      case "non livré":
        return "text-danger fw-bold";
      case "partiellement payé":
      case "en cours de livraison":
        return "text-warning fw-bold";
      default:
        return "text-secondary fw-bold";
    }
  };
  
  const updateDevisStatus = async (id, newStatus) => {
    try {
      await DevisService.updateDevisStatus(id, newStatus);
      fetchUserDevis();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut :", error);
    }
  };

  const getAvailableStatusOptions = (currentStatus) => {
    const allStatuses = ["Nouveau", "En cours", "Traité"];
    return currentStatus === "En cours" || currentStatus === "Traité"
      ? allStatuses.filter((s) => s !== "Nouveau")
      : allStatuses;
  };

  const handleDeleteDevis = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce devis ?")) {
      await DevisService.deleteDevis(id);
      fetchUserDevis();
    }
  };

  useEffect(() => {
    if (currentUser?.userId) {
      fetchUserDevis();
    }
  }, [currentUser?.userId]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const indexOfLastDevis = (currentPage + 1) * itemsPerPage;
  const indexOfFirstDevis = indexOfLastDevis - itemsPerPage;
  const currentDevis = devisList
    ? devisList
        .sort((a, b) => new Date(b.dateSoumission) - new Date(a.dateSoumission))
        .slice(indexOfFirstDevis, indexOfLastDevis)
    : [];

  const fetchFacturesStatus = async (clientId) => {
    try {
      const status = await CompaniesService.getFacturesStatus(clientId);
      console.log("Fetched Factures Status:", status); // Log the fetched status

      setFactureStatus((prev) => ({ ...prev, [clientId]: status }));
    } catch (error) {
      console.error("Error fetching factures status:", error);
    }
  };

  useEffect(() => {
    if (currentDevis.length > 0) {
      currentDevis.forEach((devis) => {
        if (devis?.clientId && !factureStatus[devis?.clientId?._id]) {
          fetchFacturesStatus(devis?.clientId?._id);
        }
      });
    }
  }, [currentDevis, factureStatus]); // Add factureStatus as a dependency to ensure it's updated before refetching

  const renderCardContent = (devis) => (
    <div
      className={`card-body devis-list-user ${
        currentUser?.role === "visitor" ? "grayed-out" : ""
      }`}
    >
      <div className="col-lg-12 d-flex align-items-center justify-content-between">
        <h5>Réf devis</h5>
        <div className="d-flex align-items-center">
          {["gestionnaire", "admin"].includes(currentUser?.role) ? (
            <select
              className={`status-select ${getStatusColor(devis?.statut)}`}
              value={devis?.statut}
              onChange={(e) => updateDevisStatus(devis?._id, e.target.value)}
            >
              {getAvailableStatusOptions(devis?.statut).map((statusOption) => (
                <option key={statusOption} value={statusOption}>
                  {statusOption}
                </option>
              ))}
            </select>
          ) : (
            <span
              className={`status-select disabled ${getStatusColor(
                devis?.statut
              )}`}
            >
              {devis?.statut}
            </span>
          )}

          <div className="position-relative">
            <button
              className="btn btn-sm mx-2"
              onClick={() => toggleMenu(devis?._id)}
              disabled={currentUser?.role === "visitor"}
            >
              <ToggleMenuIcon />
            </button>

            {activeMenu === devis?._id && (
              <div className="show custom-dropdown">
                <button
                  className="btn btn-link"
                  onClick={async () => {
                    if (
                      ["admin", "gestionnaire"].includes(currentUser?.role) &&
                      devis.statut !== "Traité"
                    ) {
                      await DevisService.updateDevisStatus(
                        devis._id,
                        "En cours"
                      );
                    }
                    navigate(`/devis/${devis._id}`);
                  }}
                  disabled={currentUser?.role === "visitor"}
                >
                  {t("Consulter")}
                </button>
                <button
                  className="btn btn-link"
                  onClick={() => {
                    setSelectedDevis(devis);
                    setIsEditModalOpen(true);
                  }}
                  disabled={devis.statut === "Traité"}
                >
                  {t("Modifier")}
                </button>
              </div>
            )}
          </div>

          <span>
            <button
              className="delete-devise-user"
              onClick={() => handleDeleteDevis(devis._id)}
              disabled={currentUser?.role === "visitor"}
            >
              <img src={icondeleteDevise} alt="delete devis" />
            </button>
          </span>
        </div>
      </div>

      <div className="col-lg-12 d-flex align-items-center justify-content-start">
        <div className="card-miniTitle company-name">
          {t("Nom de l'entreprise :")}
        </div>
        <div className="card-miniTitle company-name py-2">{devis?.company}</div>
      </div>

      <div className="col-lg-12 d-flex align-items-center justify-content-start">
        <div className="card-miniTitle company-name">
          {t("Secteur d'activité:")}
        </div>
        <div className="card-miniTitle company-name py-2">
          {devis?.activitySector}
        </div>
      </div>
      <br />
      {/* <div className="row">
        <div className="col-lg-2 company-name py-2 estimate-devis">
          <div className="d-flex align-items-center">
            <img src={iconDevise} alt="devise icon" className="logo me-2" />
            <span>
              {devis?.budgetEstime}
              {devis?.currency === "EUR" ? "€" : "$"}
            </span>
          </div>
        </div>
        <div className="col-lg-6 company-name py-2 estimate-devis">
          <div className="d-flex align-items-center">
            <img src={iconDate} alt="date icon" className="logo me-2" />
            <span>{devis?.dateSoumission?.split("T")[0]}</span>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column">
        <div>
          <span className="me-2">Livraison :</span>
          <span
            className={getFactureStatusColor(
              factureStatus[devis.clientId?._id]?.livraisonStatus
            )}
          >
            {factureStatus[devis.clientId?._id]?.livraisonStatus ||
              "Chargement..."}
          </span>
        </div>

        <div>
          <span className="me-2">Paiement :</span>
          <span
            className={getFactureStatusColor(
              factureStatus[devis.clientId?._id]?.paiementStatus
            )}
          >
            {factureStatus[devis.clientId?._id]?.paiementStatus ||
              "Chargement..."}
          </span>
        </div>
      </div> */}
      <div className="row align-items-center">
        <div className="col-lg-2 company-name py-2 estimate-devis">
          <div className="d-flex align-items-center">
            <img src={iconDevise} alt="devise icon" className="logo me-2" />
            <span>
              {devis?.budgetEstime}
              {devis?.currency === "EUR" ? "€" : "$"}
            </span>
          </div>
        </div>

        <div className="col-lg-4 company-name py-2 estimate-devis">
          <div className="d-flex align-items-center">
            <img src={iconDate} alt="date icon" className="logo me-2" />
            <span>{devis?.dateSoumission?.split("T")[0]}</span>
          </div>
        </div>

        <div className="col-lg-6 company-name py-2 estimate-devis align-items-end ">
          <div className="d-flex flex-column border rounded p-3 devis-list-user shadow-sm">
            <div className="mb-2">
              <strong className="me-2">Livraison :</strong>

              <span
                className={getFactureStatusColor(
                  factureStatus[devis.clientId?._id]?.livraisonStatus
                )}
              >
                {factureStatus[devis.clientId?._id]?.livraisonStatus ||
                  "Chargement..."}
              </span>
            </div>

            <div>
              <strong className="me-2">Paiement :</strong>

              <span
                className={getFactureStatusColor(
                  factureStatus[devis.clientId?._id]?.paiementStatus
                )}
              >
                {factureStatus[devis.clientId?._id]?.paiementStatus ||
                  "Chargement..."}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section id="UserDevisDetails">
      <div className="container-fluid mt-4 user-devis-container">
        {loading && <p>{t("chargement")}...</p>}
        {errors.hasError && (
          <div className="alert alert-danger">{errors.msg}</div>
        )}

        <div className="row">
          {Array.isArray(currentDevis) &&
            currentDevis.map((devis) => (
              <div
                key={devis._id}
                className={`devis-item ${
                  viewMode === "grid" ? "col-lg-6" : "col-12"
                }`}
              >
                <div
                  className={`card ${
                    viewMode === "grid" ? "card-view" : "list-view"
                  } w-100 mb-3`}
                >
                  {renderCardContent(devis)}
                </div>
              </div>
            ))}
        </div>

        <div className="pagination-container">
          <ReactPaginate
            previousLabel={
              <>
                <FaChevronLeft /> Pré
              </>
            }
            nextLabel={
              <>
                {"Suiv"} <FaChevronRight />
              </>
            }
            breakLabel={"..."}
            pageCount={Math.ceil(devisList.length / itemsPerPage)}
            onPageChange={handlePageChange}
            containerClassName={
              "pagination d-flex justify-content-center align-items-center"
            }
            activeClassName={"active"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
          />
        </div>

        {isEditModalOpen && selectedDevis && (
          <EditDevis
            show={isEditModalOpen} // ← corriger ici
            handleClose={() => setIsEditModalOpen(false)}
            user={selectedDevis} // ← corriger ici aussi (pas `selectedUser`)
            onUserUpdated={() => {
              setIsEditModalOpen(false);
              // Tu peux relancer un fetch si nécessaire
            }}
            fetchUserDevis={fetchUserDevis}
          />
        )}
      </div>
    </section>
  );
}

export default DevisUser;
